import styled from 'styled-components';

const Container = styled.div``;
export default Container;
